import { render, staticRenderFns } from "./CallStack.vue?vue&type=template&id=bc3e2e9c"
import script from "./CallStack.vue?vue&type=script&lang=js"
export * from "./CallStack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports